import React from 'react';
import { FadeIn } from './ui/FadeIn';
import { Sparkles } from 'lucide-react';
export function MechanismSection() {
  return <section className="py-24 relative overflow-hidden" data-id="element-155">
      {/* Background elements */}
      <div className="absolute top-0 right-0 w-96 h-96 bg-gold-500/5 rounded-full blur-[100px] pointer-events-none" data-id="element-156"></div>
      <div className="absolute bottom-0 left-0 w-96 h-96 bg-gold-500/5 rounded-full blur-[100px] pointer-events-none" data-id="element-157"></div>

      <div className="max-w-4xl mx-auto px-6 lg:px-8 text-center relative z-10" data-id="element-158">
        <FadeIn data-id="element-159">
          <div className="inline-flex items-center justify-center p-3 bg-gold-500/10 rounded-full mb-8" data-id="element-160">
            <Sparkles className="w-6 h-6 text-gold-400" data-id="element-161" />
          </div>
          <h2 className="text-4xl md:text-5xl font-serif text-white mb-6" data-id="element-162">
            El Vacío Psicológico
          </h2>
          <h3 className="text-xl md:text-2xl text-gold-400 font-serif italic mb-12" data-id="element-163">
            (Efecto Zeigarnik)
          </h3>
        </FadeIn>

        <FadeIn delay={0.2} data-id="element-164">
          <div className="space-y-6 text-lg md:text-xl text-gray-300 leading-relaxed font-light text-left md:text-center" data-id="element-165">
            <p data-id="element-166">
              Este no es un libro de "consejos de amor". Es un{' '}
              <strong className="text-white font-medium" data-id="element-167">
                protocolo de psicología aplicada
              </strong>{' '}
              diseñado para interrumpir su patrón de seguridad.
            </p>
            <p data-id="element-168">
              Al aplicar "La Sombra", generas una tarea incompleta en su
              subconsciente. Su cerebro entrará en un ciclo de ansiedad positiva
              que solo podrá cerrar volviendo a buscarte a ti.
            </p>
            <p className="text-2xl font-serif text-white italic pt-6 border-t border-gold-500/20 mt-8" data-id="element-169">
              Pasas de ser una opción segura a ser un misterio que él necesita
              resolver.
            </p>
          </div>
        </FadeIn>
      </div>
    </section>;
}